import {
  FC,
  InputHTMLAttributes,
  useMemo,
  useCallback,
  useState,
} from 'react'
import { useField } from 'formik'
import classnames from 'classnames'
import { isPresent } from 'utils'
import Wrapper from '../Wrapper'
import Styles from './Input.module.sass'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * Field label
   */
  label?: string | null,

  /**
   * Field is required
   */
  required?: boolean,

  /**
   * Classes for the wrapper
   */
  wrapperClassName?: string,
}

const Input: FC<InputProps> = ({
  label,
  name,
  required = false,
  disabled = false,
  className,
  wrapperClassName,
  ...restProps
}) => {
  const [field, meta] = useField(name || '')
  const [didFocus, setDidFocus] = useState(false)
  const handleFocus = useCallback(
    () => setDidFocus(true),
    []
  )
  const showFeedback =
    (!!didFocus && (`${field.value as string}`)?.trim()?.length > 0) || meta.touched

  const inputClasses = useMemo(() => classnames({
    [Styles.input]: true,
    [Styles.inputError]: showFeedback && meta.error,
    [Styles.inputDisabled]: disabled,
    [className || '']: isPresent(className),
  }), [className, disabled, meta.error, showFeedback])

  return name ? (
    <Wrapper
      value={field?.value}
      label={label}
      required={required}
      disabled={disabled}
      meta={meta}
      showFeedback={showFeedback}
      className={wrapperClassName}
    >
      <input
        disabled={disabled}
        className={inputClasses}
        onFocus={handleFocus}
        {...restProps}
        {...field}
      />
    </Wrapper>
  ) : null
}

export default Input
